var initTab = require( "../../src/js/lib/init-tab.js" );

function Tab(el) {
  const setTabHeight = () => {
    tabPanels = [...el.querySelectorAll('[role="tabpanel"]')]

    if (tabPanels.length) {
      maxPanelsHeight = tabPanels.reduce((max, tabPanel) => {
        return tabPanel.scrollHeight > max ? tabPanel.scrollHeight : max
      }, 0)
      tabPanels[0].parentNode.style.height = `${maxPanelsHeight}px`
    }
  }

  initTab()
  setTimeout(setTabHeight, 500)

  window.addEventListener('resize', setTabHeight);
}

module.exports = Tab;
